import { type FC } from 'react';
import { graphql, useFragment } from 'react-relay';
import { FormattedMessage, FormattedNumber } from 'dibs-react-intl';
import { StarRating } from 'dibs-elements/exports/StarRating';
import { useSellerRating } from '../hooks/useSellerRating';

// types
import { type SharedStarRating_seller$key } from './__generated__/SharedStarRating_seller.graphql';

// styles
import dibsCss from 'dibs-css';
import classnames from 'classnames';

const sellerFragment = graphql`
    fragment SharedStarRating_seller on Seller {
        ...useSellerRating_seller
    }
`;

export const SharedStarRating: FC<{
    seller: SharedStarRating_seller$key | null | undefined;
    size?: 'small' | 'medium';
}> = ({ seller: sellerRef, size = 'small' }) => {
    const seller = useFragment(sellerFragment, sellerRef);
    const feedbackRating = useSellerRating({ seller });

    return (
        <div className={classnames(dibsCss.inlineFlex, dibsCss.flexRow, dibsCss.itemsBaseline)}>
            {!!feedbackRating && (
                <span
                    className={classnames(
                        dibsCss.mrXsmall,
                        size === 'medium'
                            ? dibsCss.sassyFontBodySizeMediumTypeHeavy
                            : dibsCss.sassyFontBodySizeSmallTypeHeavy
                    )}
                >
                    <FormattedNumber
                        style="decimal"
                        value={feedbackRating}
                        minimumFractionDigits={1}
                    />
                </span>
            )}
            <StarRating rating={feedbackRating} size="x-small" />
            {!feedbackRating && (
                <span
                    className={classnames(
                        dibsCss.mlXsmall,
                        dibsCss.whitespaceNowrap,
                        size === 'medium' ? dibsCss.sassyFontBody : dibsCss.sassyFontBodySizeSmall
                    )}
                >
                    <FormattedMessage
                        id="SharedStarRating.noReviews"
                        defaultMessage="No Reviews Yet"
                    />
                </span>
            )}
        </div>
    );
};
